import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import type { RootState, TypedDispatch } from 'src/setup';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: any = () => useDispatch<TypedDispatch<RootState>>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
